import Component from "../component.abstract";
import GridContents from "./grid-contents";

export default class GridSheet extends Component {
  private cards: HTMLCollection;
  constructor(private props: unknown, element: HTMLElement) {
    super(props,element);
    this.cards = element.children;
  }
  mounted(): void {
    if (this.cards.length) {
      this.init();
    } else {
      this.element.remove();
    }
  }
  init(): void {
    new GridContents(this.element);
    // remove some potential extra classes
    for (let i = 0; i < this.cards.length; i++) {
      this.cards[i].classList.remove("action");
      this.cards[i].classList.remove("impact");
      this.cards[i].classList.remove("squared");
      this.cards[i].classList.remove("crushed");
    }
    for (let i = 0; i < this.cards.length; i++) {
      // if we are on a full width content object or on the first object of a cut row, we have to set the style classes
      if (this.cards[i].classList.contains("cut")) {
        // the first element is the left one
        this.cards[i].classList.add("cleft");
        if (
          i != 0 &&
          i != this.cards.length - 2 &&
          i != this.cards.length - 1
        ) {
          this.cards[i].classList.remove("fill");
        }
        if (i < this.cards.length - 1) {
          this.cards[i + 1].classList.add("cright");
          if (i != 0 && i != this.cards.length - 2) {
            this.cards[i + 1].classList.remove("fill");
          }
          i++;
        }
      } else {
        if (i != 0 && i != this.cards.length - 1) {
          this.cards[i].classList.remove("fill");
        }
      }
    }
  }
}
